import { Disclaimer, DISCLAIMER_NAMES } from '@fff-web/cms';
import { appEnv } from '../../../utils/env';
import * as styles from './UpgradeDisclaimer.module.scss';

const UpgradeDisclaimer = () => {
  return (
    <div className={styles.upgradeDisclaimerContainer}>
      <Disclaimer name={DISCLAIMER_NAMES.upgradeToday} env={appEnv} />
      <br />
      <br />
      *Savings based on comparison to Seasonal Subscription price for four boxes. Free shipping in
      the contiguous US only.
    </div>
  );
};

export default UpgradeDisclaimer;
